<script lang="ts" setup>
import { Button } from 'primevue'
import { computed } from 'vue'
import { useRouter } from 'vue-router'

import { useUserStore } from '@/stores/user-store'

const router = useRouter()
const userStore = useUserStore()

const isVisible = computed(() => userStore.cookiePreference === null)

function handleAccept() {
  userStore.setCookiePreference('accepted')
}

function handleDecline() {
  userStore.setCookiePreference('declined')
}

function handleCookiePolicy() {
  router.push({ name: 'cookie-policy' })
}
</script>

<template>
  <Transition name="slide-up">
    <div v-if="isVisible" class="cookie-banner" role="dialog" aria-label="Cookie consent banner">
      <div class="cookie-banner-content">
        <div class="cookie-banner-text">
          <p class="cookie-banner-message">
            {{ $t('common:cookieBannerMessage') }}
            <Button
              link
              class="cookie-banner-link"
              :label="$t('common:navCookiePolicy')"
              @click="handleCookiePolicy"
            />
          </p>
        </div>
        <div class="cookie-banner-actions">
          <Button
            :label="$t('common:cookieBannerDecline')"
            severity="secondary"
            icon="pvi pvi-x"
            @click="handleDecline"
          />
          <Button
            :label="$t('common:cookieBannerAccept')"
            icon="pvi pvi-check"
            @click="handleAccept"
          />
        </div>
      </div>
    </div>
  </Transition>
</template>

<style scoped lang="scss">
.cookie-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  background-color: white;
  border-top: 1px solid var(--surface-border);
  padding: 1rem;
}

.cookie-banner-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
}

.cookie-banner-text {
  flex: 1;
}

.cookie-banner-message {
  margin: 0;
  color: var(--p-text-color);
  text-align: center;

  @media (min-width: 768px) {
    text-align: left;
  }
}

.cookie-banner-link {
  :deep(.p-button-label) {
    text-decoration: underline;
  }
}

.cookie-banner-actions {
  display: flex;
  gap: 0.75rem;
  flex-shrink: 0;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.3s ease;
}

.slide-up-enter-from,
.slide-up-leave-to {
  opacity: 0;
  transform: translateY(100%);
}
</style>
